const MESSAGE_POSITION = ["top", "bottom"];
export { MESSAGE_POSITION };
